export enum ActivityTabsInEditEnum {
  DOCUMENTATIONS = 0,
  CHANGES = 1,
  THEME = 2
}
export enum ActivityTabsInViewEnum {
  DOCUMENTATIONS = 0,
  CHANGES = 1
}
